import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { docExtensions, imageExtensions } from "Helpers/File";

import FileUploader from "Components/Admin/FileUploader";
import Checkbox from "Components/Admin/Form/Checkbox";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const UpdateProjectDocument = ({ file, loading, defaultFiles, setAllDocs }) => {
  const [docs, setDocs] = useState(defaultFiles || []);

  useEffect(() => {
    setAllDocs((prev) => ({
      ...prev,
      [file?.id]: docs,
    }));
  }, [docs]);

  return (
    <Form>
      <FileUploader
        key={file?.id}
        allowMultiple={false}
        label={file?.display_name}
        loading={loading}
        allowedExtensions={[...imageExtensions, ...docExtensions]}
        setFiles={(file) =>
          setDocs((prev) => [
            ...prev,
            {
              file: file[0],
              name: file[0].name,
              sponsor_can_see: false,
            },
          ])
        }
        required
      />

      {docs.map((doc) => (
        <S.File key={doc.name}>
          <S.FileInfos>
            <h2>{doc.name}</h2>

            <GetIcon
              name="X"
              onClick={() =>
                setDocs((prev) => prev.filter((d) => d.name !== doc.name))
              }
            />
          </S.FileInfos>

          <Checkbox
            name="sponsor_can_see"
            label="Patrocinador pode ver"
            defaultChecked={doc.sponsor_can_see}
            value={doc.sponsor_can_see}
            onChange={() => {
              const current_docs = docs;

              const doc_index = current_docs.findIndex(
                (d) => d.name === doc.name,
              );

              current_docs[doc_index].sponsor_can_see = !doc.sponsor_can_see;

              setDocs(current_docs);
            }}
          />
        </S.File>
      ))}
    </Form>
  );
};

export default UpdateProjectDocument;
